import { useEffect, useState } from 'react';

const QUERY = '(max-width: 1023px)';

/** Coincide con el breakpoint `lg:` de Tailwind (contenido “móvil” / tablet estrecha). */
export function useViewportBelowLg(): boolean {
  const [below, setBelow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setBelow(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return below;
}
